import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoneyback = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "_10DayMoneyBack",
	"data-name": "10DayMoneyBack",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_17186",
		"data-name": "Group 17186",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12731",
				"data-name": "Path 12731",
				d: "M16,2V6",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12732",
				"data-name": "Path 12732",
				d: "M8,2V6",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12733",
				"data-name": "Path 12733",
				d: "M3,9H21",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12734",
				"data-name": "Path 12734",
				d: "M19,4H5A2,2,0,0,0,3,6V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V6A2,2,0,0,0,19,4Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_17187",
				"data-name": "Group 17187",
				transform: "translate(-2.8)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Path_12735",
						"data-name": "Path 12735",
						d: "M10.6,13.82l1.46-1.32",
						fill: "none",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1.5
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_12736",
						"data-name": "Path 12736",
						d: "M10.72,17.5H13.4",
						fill: "none",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1.5
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_12737",
						"data-name": "Path 12737",
						d: "M12.06,12.5v5",
						fill: "none",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 1.5
					})
				]
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				id: "Ellipse_654",
				"data-name": "Ellipse 654",
				cx: 2,
				cy: 2.55,
				rx: 2,
				ry: 2.55,
				transform: "translate(12.2 12.4)",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12738",
		"data-name": "Path 12738",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgMoneyback;
